export default "__VITE_ASSET__DlZgEISJ__"